import { formatTicker } from '@api';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { useNavigateToAssetOverview } from '@terminal/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { RatingPill } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/rating-pill/RatingPill';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PriceChange } from '../PriceChange';
import { CompanyCardProps } from './company-card-types';
import styles from './CompanyCard.module.scss';

export const SecondaryCompanyCard = ({
  company,
  entity,
  source,
  referenceDate,
  hideRelationship = false,
}: CompanyCardProps) => {
  const { t } = useTranslation(['earnings']);
  const { navigateToPage } = useNavigateToAssetOverview();

  const handleNavigate = () =>
    navigateToPage({ entityTag: company.entity_tag, source });

  return (
    <div className={styles.root} onClick={handleNavigate}>
      <div className={styles.headerWrapper}>
        <div className={styles.assetDetailsWrapper}>
          <AssetLogoContainer size={40} entity={entity} />
          <div className={styles.assetNameWrapper}>
            <span className={styles.assetNameLabel}>
              {entity.name_short || entity.name}
            </span>
            <span className={styles.flexWrapper}>
              <span className={styles.assetTickerLabel}>
                {formatTicker(entity)}
              </span>
              <PriceChange companyData={entity} referenceDate={referenceDate} />
            </span>
          </div>
        </div>
        <RatingPill rating={company.rating} />
      </div>
      <div className={styles.descriptionLabel}>{company.description}</div>
      {!hideRelationship && company.relationship && (
        <div className={styles.relationLabel}>{`${t(
          'earnings:earningsInsight.drawer.earningsPreview.relationship'
        )} ${company.relationship}`}</div>
      )}
    </div>
  );
};
